define(["./arrangementModule", "text!./nlgArrangementContent.html"], function (arrangementModule, nlgArrangementContentTemplate) {
    "use strict";

    return arrangementModule.directive("nlgArrangementContent", [function () {
        return {
            restrict: "E",
            template: nlgArrangementContentTemplate
        };
    }]);
});